module.exports = __webpack_public_path__ + "img/Leste.51c824e2.svg";